var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('page-header'),_c('div',{staticClass:"page__content"},[_c(_vm.component,{key:_vm.id,tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }